// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__nmeCI","input":"styles_input__hRM+1","label":"styles_label__tqXnU"};